import { render, staticRenderFns } from "./DaysBackRequest.vue?vue&type=template&id=4a0b85b0"
import script from "./DaysBackRequest.vue?vue&type=script&lang=js"
export * from "./DaysBackRequest.vue?vue&type=script&lang=js"
import style0 from "./DaysBackRequest.vue?vue&type=style&index=0&id=4a0b85b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports